/*
 * Privacy Messages
 *
 * This contains all the text for the Privacy component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Privacy.title',
    defaultMessage: 'Privacy Policy',
  },
});
